import CampaignDataService from './CampaignDataService';

export default angular.module('edge.platform.campaign', []).provider('CampaignDataService', CampaignDataService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/campaign/module.js
// module id = 1883
// module chunks = 0